import React from 'react';
import { FormattedMessage } from '../../../taboola-common-frontend-modules/i18n';

export const SaveAsDraftLabel = () => (
    <FormattedMessage id="app.actionButtons.save.as.draft" defaultMessage="Save as draft" />
);
